import { EmbedContentBase } from "@jog/react-components";
export const EmbedContent = ({ slice: { primary, items }, className }) => (<div className={className}>
        <EmbedContentBase items={items} height={primary.height}/>
    </div>);
